import { render } from "./FormCargoComponent.vue?vue&type=template&id=f0e5dd20"
import script from "./FormCargoComponent.vue?vue&type=script&lang=js"
export * from "./FormCargoComponent.vue?vue&type=script&lang=js"

import "./FormCargoComponent.vue?vue&type=style&index=0&id=f0e5dd20&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__